query tipoPerfisSelect($where: EnumItemDTOFilterInput) {
    data: tiposPerfis(where: $where)  {
        label
        value
    }
}
